
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post22() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Dúvida saúde - diabetes - Diabetes dicas</title>
        <meta 
          name="description" 
          content="Gente, boa dia!

Eu fui diagnosticada com diabetes fazem uma semaninhas e comecei uma reeducação alimentar (fui na nutri). Mas não estou acompanhando a glicemia, não tenho o aparelho ainda. Vocês acham que precisa comprar? Ou dá pra fazer na farmácia de vez em quando?

Obrigado!"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Rita Anton &#183; 06/08/2024
          </p>
        </div>
        <p className="heading4 bottom-margin-s">Diabetes dicas</p>


        <p className="body content bottom-padding-s">
            Gente, boa dia!<br/><br/>Eu fui diagnosticada com diabetes fazem uma semaninhas e comecei uma reeducação alimentar (fui na nutri). Mas não estou acompanhando a glicemia, não tenho o aparelho ainda. Vocês acham que precisa comprar? Ou dá pra fazer na farmácia de vez em quando?<br/><br/>Obrigado!
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/22')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  2 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Bom dia!<br/><br/>Primeiramente, gostaria de te parabenizar pela iniciativa em buscar reeducação alimentar com o apoio de uma nutricionista. Isso é uma etapa muito importante no manejo da diabetes. Em relação à medição da glicemia, a frequência depende muito de caso para caso, baseado nas orientações do seu médico ou endocrinologista.<br/><br/>Para quem acabou de descobrir a diabetes, monitorar os níveis de glicose sanguínea pode ser fundamental para entender como diferentes alimentos, atividades físicas e estresses influenciam os seus níveis de açúcar no sangue. Isso pode ajudar a ajustar a dieta, a atividade física e até a medicação, se necessário.<br/><br/>Muitas pessoas com diabetes medem seus níveis de glicose em casa com um glicosímetro (o aparelho de medir glicemia) por ser uma forma prática e oferecer resultados imediatos. Ter um em casa pode ser bastante conveniente, pois permite que você faça o monitoramento mais regularmente.<br/><br/>Fazer a medição na farmácia ocasionalmente é uma opção, mas talvez não ofereça a frequência e a conveniência necessárias para um controle eficaz, principalmente no início, quando você ainda está ajustando sua dieta e estilo de vida.<br/><br/>Recomendo conversar com seu médico ou endocrinologista sobre a necessidade e a frequência das medições. Eles podem orientar se no seu caso é indicado adquirir um glicosímetro e como utilizá-lo corretamente, assim como definir um plano de monitoramento ajustado às suas necessidades.<br/><br/>Lembrando sempre: sua saúde é prioridade, e o acompanhamento médico é essencial para um controle efetivo da diabetes. Se tiver mais dúvidas, estamos aqui para ajudar!
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 06/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/22')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Vitor Machado &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/84-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Olá amigos,<br/>O que usar nas alergias pós químio vermelha? Vocês tem alguma sugestão?<br/>Minha mãe está nas virilhas bem vermelha e com coceira.<br/>O médico não indicou nada , mas já vi outras pessoas com mesmos sintomas que usaram algo para aliviar, mas não sei oque.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/84')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Tomaz Silveira &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/81-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, já fazem suas semanas que meço minha glicose em jejum a após fazer 1 hora de musculação e 50 minutos de caminhada, e quando meço antes do almoço sem comer nada, ela aumenta entre 30 e 40 pontos.<br/><br/>Estou estranhando porque isso nunca aconteceu antes, sempre reduzia cerca de 20 a 30 pontos após os exercícios, mas semana passada de 210 em jejum foi pra 265 após os exercícios e hoje 235 foi  pra 262 após exercícios. <br/><br/>Oque vocês acham?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/81')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Paula Farber &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/28-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, tenho diabetes tipo 2 e dor nas pernas, muita ardência a noite. Vocês já tiveram isso? Já fizeram uso de vitamina B12 e D e ajudou?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/28')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        2 comentários
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Fernanda Salles &#183; 23/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/149-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde, pessoal!<br/>O que fazer pra aumentar as plaquetas?<br/>A minha irmã está em tratamento paliativo faz mais de um ano, e não está conseguindo aumentar as plaquetas de jeito nenhum, e ela precisa disso para poder tomar os remédios da quimioterapia.<br/>Ela já recebeu transfusão de sangue, está tomando ferro há quatro dias, comendo feijão, beterraba e bebendo água de coco, mas sem resultados.<br/>Alguma ideia?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/149')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Leonardo Silveira &#183; 18/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/2-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Os benefícios para saúde de ter um Border Collie  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Há anos atrás, quando estava na faculdade, eu costumava correr na rua em algum parque 2 ou 3 vezes na semana, por cerca de 30 minutos. Com o tempo, e conforme fui ficando mais ocupado, acabei deixando esse bom hábito de lado. E uma vez que o hábito de exercício físico normalmente traz consigo outros hábitos, como de uma alimentação mais saudável e menos bebida alcoólica, esses também foram se deteriorando com o tempo. Consequentemente, ao longo dos anos sutilmente resultados disso foram surgindo, como aumento de peso e menor disposição.<br/><br/>Dois anos atrás, porém, decidi junto com minha esposa adotar um cachorro, e escolhemos uma Border Collie. A nova integrante da família, conforme nós esperávamos, nos forçou a uma série de mudanças na rotina. Eu fiquei responsável pelos passeios duas vezes por dia: às 6 da manhã, antes do trabalho, e no final da tarde. Isso me forçou diretamente e sem rodeios a iniciar uma atividade física disfarçada, que foram as caminhadas com nossa cachorra, que foram aumentando de duração e intensidade conforme ele crescia.<br/><br/>A raça Border Collie é conhecida por ser a raça mais inteligente, e também de alta energia. E sem dúvida existe alguma verdade nessa afirmação. As caminhadas deixaram de ser o bastante para a nossa cachorra, e para conseguir gastar sua energia e mantê-la saudável treinamos ela para jogar frisbee: pegar o disco no ar após jogarmos e traze-lo novamente para nós, em um ciclo aparentemente infinito de arremessos. Ela aprendeu rapidamente o esporte e se tornou um dos melhores cachorros que já vimos pegando o disco no ar em saltos acrobáticas.<br/> <br/>Porém, as caminhadas intensas duas vezes por dia com ela me fez lembrar de como eu me sentia bem após uma corrida intensa na época da faculdade, e como estava disposto no dia seguinte para o estudo e trabalho. Com isso, comecei aos poucos a correr junto de minha cachorra na rua. Essa corrida foi aumentando, primeiro somente a tarde alguns dias, depois mais alguns dias de manhã, e por fim, hoje corro com ela todos os dias de manhã e a tarde.<br/><br/>Isso mantém minha cachorra feliz e nós dois saudáveis, além de me manter disposto e com mais energia do que me sentia em anos. E hoje nem penso em não fazer isso, simplesmente porque sei como me sinto e vejo como ela fica feliz na horário dos nossos passeios. Esse são alguns, dos muitos benefícios de ter um Border Collie (ou qualquer outro cachorro) como companheiro.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/2')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
